// Static role values used across the app.
//
// Roles in Upstrive Education come in two flavours:
//  - Numeric roles, defined per institution in the `institution_roles_model`
//    collection (starting at 1; higher number = higher priority). These are
//    the "dynamic" roles surfaced in the role picker.
//  - Static (non-numeric) roles, assigned directly on the user document:
//      0 (numeric)         -> student
//      SCHOOL_ADMIN_ROLE   -> super admin for the institution (full access)
//      IT_ACCESS_ROLE      -> limited IT staff role (user management only)
export const STATIC_ROLES = {
    STUDENT: 0,
    SCHOOL_ADMIN: 'school_admin',
    IT_ACCESS: 'it_access',
}

export const SCHOOL_ADMIN_ROLE = STATIC_ROLES.SCHOOL_ADMIN
export const IT_ACCESS_ROLE = STATIC_ROLES.IT_ACCESS

// True when the user is the IT Access role (user management only).
export const isItAccess = (user) => user?.role === IT_ACCESS_ROLE

// True when the user is an institution admin: either the static super admin
// or a dynamic role with full coverage ("All students").
export const isAdmin = (user) =>
    user?.role === SCHOOL_ADMIN_ROLE || user?.role_coverage?.target_text === 'All students'

// True when the user gets the Management staff tabs (Teacher management,
// Inactivity). Primary-school UI hides them regardless of role.
export const canManageStaff = (user, primaryUI) =>
    !primaryUI && (user?.role === SCHOOL_ADMIN_ROLE || user?.role_coverage?.target_text === 'All students' || isItAccess(user))

// True when the user can read inactivity data. The backend keeps /api/inactivity
// 403 for IT Access (student engagement data), so they're excluded here.
export const canSeeInactivity = (user, primaryUI) => canManageStaff(user, primaryUI) && !isItAccess(user)
